import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const latest = articles.slice(0, 3);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            影视资讯
          </h2>
          <p className="text-sm text-foreground-500 mt-1">最新影视行业动态与深度分析</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {latest.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group rounded-lg overflow-hidden bg-background-50 border border-background-200 transition-all duration-300 hover:border-primary-200 cursor-pointer"
          >
            <div className="aspect-video overflow-hidden">
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                <span>{article.publishDate}</span>
                <span className="text-foreground-300">·</span>
                <span>{article.views.toLocaleString()} 阅读</span>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-2 line-clamp-2">{article.summary}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}